/**
 * What a user may do with the clip edit ("pen") control.
 *
 * This is a UI hint only. The server independently enforces manager rights on
 * the direct-write route, so a stale cached user cannot gain access here.
 *
 * @param {Object} user - The cached current user (see getUser in ./utilities)
 * @returns {'immediate'|'request'|null} null means the pen is hidden entirely
 */
export const getClipEditMode = (user) => {
    if (!user) return null;
    if (user.manager === true) return 'immediate';
    if ((user.roles || []).includes('ROLE_COACH')) return 'request';

    return null;
};
